export default "__VITE_ASSET__Q00dJO1f__"